export const TRANSFER_TITLE_MAX_LENGTH = 140;

export const sanitizeSingleLineTitle = (value) =>
	String(value || "")
		.replace(/[\r\n|]+/g, " ")
		.replace(/\s+/g, " ")
		.trim();

export const sanitizePrzekazTitleInput = (value) => {
	const withoutPrefix = String(value || "").replace(/^PRZEK:\s*/i, "");
	return sanitizeSingleLineTitle(withoutPrefix).replace(/[{}]/g, "").trim();
};

export const buildPrzekazTitlePreview = (titleText, fallbackText) =>
	`PRZEK: ${sanitizePrzekazTitleInput(titleText || fallbackText || "")}`;

export const buildTransferTitlePreview = ({
	personName,
	personLastName,
	wplywOwnId,
	personOwnId,
	transferOwnId,
	titleSuffix,
	customTitle,
}) => {
	const suffix = sanitizeSingleLineTitle(titleSuffix);
	const base = sanitizeSingleLineTitle(customTitle);
	if (base) {
		return sanitizeSingleLineTitle(`${base}${suffix ? ` ${suffix}` : ""}`);
	}

	return sanitizeSingleLineTitle(
		`Świadczenie dla ${String(personName || "")} ${String(personLastName || "")} PRZELEW.ID ${String(wplywOwnId || "")}.${String(personOwnId || "")}.${String(transferOwnId || "")}${suffix ? ` ${suffix}` : ""}`,
	);
};

export const splitOverflowText = (
	value,
	limit = TRANSFER_TITLE_MAX_LENGTH,
) => ({
	visible: String(value || "").slice(0, limit),
	overflow: String(value || "").slice(limit),
});
